import React from "react";
import "./Butterbar.css";

const Butterbar = () => {
  return (
    <div class="butterbar active">
      <div class="bar"></div>
    </div>
  );
};

export default Butterbar;
